import { Box, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import imgInfo from "../../../../../../Assets/StoryAgent/screen_6.png";
import ScreenContainer from "./ScreenContainer";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

interface ScreenProps {
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  t: (key: string) => ReactNode;
  theme: Theme;
}

const Screen = (props: ScreenProps) => {
  const { t, screen, setStory } = props;
  const { main } = props.theme.palette.error;

  const handleNextScreen = () => setStory({ screen: screen + 1, transition: 2 });

  return (
    <ScreenContainer>
      <Box sx={styles.topBox}>
        <Box sx={styles.title}>{t("commons.title")}</Box>
        <Box sx={styles.text_2}>
          {t("agent.stage_three.screen_6.text_2_part_1")}
          <span style={{ ...styles.span }}>{t("agent.stage_three.screen_6.text_2_part_2")}</span>
          {t("agent.stage_three.screen_6.text_2_part_3")}
          <span style={{ ...styles.span, color: main }}>{t("agent.stage_three.screen_6.text_2_part_4")}</span>.
          {t("agent.stage_three.screen_6.text_2_part_5")}
        </Box>
      </Box>
      <Box sx={{ position: "relative" }}>
        <img src={imgInfo} alt="" style={styles.imgInfo} />
        <Button sx={styles.btn} onClick={handleNextScreen} variant="contained" endIcon={<ArrowForwardIcon />}>
          {t("agent.stage_three.screen_6.btn")}
        </Button>
      </Box>
    </ScreenContainer>
  );
};

const styles = {
  imgInfo: {
    margin: "auto",
    maxHeight: "calc(65vh - 8em)",
    marginTop: "1em",
    objectFit: "contain" as "contain",
    width: "100%",
  },
  topBox: {
    textAlign: "center",
    width: "100%",
    border: "1px solid #fff",
    padding: "1.09375em 0",
  },
  title: {
    fontSize: "1.4583em",
    fontWeight: "bold",
  },
  text_2: {
    fontSize: "1.25em",
    marginTop: "1em",
  },
  text_3: {
    fontSize: "1.25em",
  },
  span: {
    fontWeight: "bold",
    fontSize: "1em",
  },
  btn: {
    position: "absolute",
    bottom: "1em",
    left: "1.5625em",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen, mapStateToProps, mapDispatchToProps);
